export default "__VITE_ASSET__BPgAgXFF__"